// src/js/components/Shared/ImportWizard/components/EqualRule.jsx
import React, { useState, useCallback } from "react";
import {
  ListItem,
  ListItemText,
  Button,
  Grid,
  TextField,
  IconButton
} from "@material-ui/core";
import LabeledAutocomplete from "js/components/Shared/Form/Fields/LabeledAutocomplete";
import DeleteIcon from "@material-ui/icons/Delete";

export default React.memo(function EqualRule({
  suggestions,
  onRemove,
  id,
  estado,
  onUpdate
}) {
  // Si `estado` no está definido, usar valor por defecto
  const [entrada, setEntrada] = useState((estado && estado.entrada) || "");
  const [salida, setSalida] = useState((estado && estado.salida) || "");

  /* ----------------------------------------------------------------------
     Cuando el usuario escribe, se actualiza el estado directamente.
  ---------------------------------------------------------------------- */
  const handleEntradaChange = useCallback(
    e => {
      const valor = e.target.value;
      setEntrada(valor);
      onUpdate({ ...estado, entrada: valor, salida }, id);
    },
    [estado, salida, id, onUpdate]
  );

  const handleSalidaChange = useCallback(
    value => {
      setSalida(value);
      onUpdate({ ...estado, entrada, salida: value }, id);
    },
    [estado, entrada, id, onUpdate]
  );

  const handleRemove = useCallback(() => onRemove(id), [onRemove, id]);

  return (
    <ListItem
      style={{ marginTop: "1%", alignItems: "flex-start", padding: "0%" }}
    >
      <ListItemText
        primary="Si el valor es igual a →"
        secondary={
          <Grid container alignItems="center" spacing={8}>
            <Grid item xs={4}>
              <TextField
                placeholder="E"
                value={entrada}
                onChange={handleEntradaChange}
                label="Valor exacto"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              {suggestions.length > 0 ? (
                <LabeledAutocomplete
                  label="Elementos"
                  isDisabled={false}
                  noOptionsMessage={() => "No se encontraron elementos"}
                  placeholder="Seleccione un elemento"
                  suggestions={suggestions}
                  value={salida}
                  onChange={handleSalidaChange}
                />
              ) : (
                <TextField
                  placeholder="Segmento 1"
                  value={salida}
                  onChange={e => setSalida(e.target.value)}
                  label="Salida"
                  style={{ width: "100%" }}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <IconButton aria-label="Borrar" onClick={handleRemove}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        }
      />
    </ListItem>
  );
});
